export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p className="footer__tagline">
          <strong>Gency03</strong> · CGF<span className="footer__cgf-full">(Chlorella Growth Factor)</span> 가공품 공식 스토어
        </p>
        <p className="footer__biz">
          <span>상호 파란디앤씨 | 대표 김양태 | 사업자등록번호 667-12-01993</span>
          <span>경기도 용인시 기흥구 중부대로746번길 14-4, 2층 201호(상하동)</span>
        </p>
        <p className="muted">© {new Date().getFullYear()} Gency03. All rights reserved.</p>
      </div>
    </footer>
  );
}
